import React, { useState, useEffect } from 'react';
import { fetchUsersList } from '../../api/auth';
import SearchDropdown from './searchDropdown';
interface Props {
  setSelectedUserName: any;
  selectedUserName: any;
  setHandleToggleChange?: any;
  label?: any;
  className?: any;
}
const SelectOwnerDropdown = ({
  selectedUserName,
  setSelectedUserName,
  setHandleToggleChange,
  label,
  className,
}: Props) => {
  const [usersList, setUsersList] = useState<any>();
  useEffect(() => {
    let payload = {
      is_pagination: false,
    };
    fetchUsersList(payload)
      .then((response) => {
        if (!response?.data?.is_error) {
          let usersData = response?.data?.content;
          const formattedUsersList: any = usersData.map((item: any) => ({
            label: `${item?.first_name} ${item?.last_name}`,
            value: item.username,
          }));
          setUsersList(formattedUsersList);
        }
      })
      .catch((e) => {});
  }, []);
  return (
    <SearchDropdown
      id={'user-dropdown'}
      placeholder={'All'}
      className={className && className}
      selectedValue={selectedUserName}
      label={label && label}
      dummyOptionText={'All'}
      options={usersList && usersList}
      onSelect={(item) => {
        setSelectedUserName(item.value);
        setHandleToggleChange && setHandleToggleChange(true);
      }}
    />
  );
};

export default SelectOwnerDropdown;
